import {
  BasicTableRowStyles,
  TableHeaderWrapper,
  TableWrapper,
} from "../../../components/common/Common.styles";
import { Typography } from "@mui/material";
import { PaginatedData } from "../../../hooks/PaginationHooks";
import CellBox from "../../../components/common/table/CellBox";
import BorderRow from "../../../components/common/table/BorderRow";
import { GroupItem } from "../../../types/groupItem";
import { t } from "i18next";
import DeleteBtn from "../../../components/common/table/DeleteBtn";
import ServerSideTableColumnHeader from "../../../components/common/table/ServerSideTableColumnHeader";
import ActionModuleIconList from "./ActionModuleIconList";
import EditIcon from "@mui/icons-material/Edit";
import { GeneralButton } from "../../../common/ui/GeneralButton";

interface Props {
  paginatedData: PaginatedData<GroupItem>;
  handleDeleteGroup?: (group: GroupItem) => void;
  handleEditGroup?: (group: GroupItem) => void;
}

export default function GroupsTable(props: Props) {
  return (
    <TableWrapper
      columnsTemplate="2fr 3fr 1fr auto"
    >
      <TableHeaderWrapper>
        <ServerSideTableColumnHeader
          fieldName="name"
          isSorted
          label={t("tableColumnHeaders.groups")}
          paginatedData={props.paginatedData}
          firstCol
        />
        <ServerSideTableColumnHeader
          isSorted={false}
          label={t("tableColumnHeaders.actionModules")}
        />
        <ServerSideTableColumnHeader
          isSorted={false}
          label={t("tableColumnHeaders.staff")}
        />
        <BorderRow />
      </TableHeaderWrapper>

      {props.paginatedData.items.map((item) =>
        <BasicTableRowStyles key={item.id}>
          <CellBox firstCol>
            <Typography>{item.name}</Typography>
          </CellBox>
          <CellBox firstCol>
            <ActionModuleIconList actionModules={item.actionModules ?? []} />
          </CellBox>
          <CellBox>
            <Typography>{item.memberCount}</Typography>
          </CellBox>
          <CellBox lastCol>
            {props.handleEditGroup && (
              <GeneralButton
                appVariant="icon"
                onClick={() => props.handleEditGroup!(item)}
              >
                <EditIcon />
              </GeneralButton>
            )}
            {props.handleDeleteGroup && (
              <DeleteBtn
                isCreateNewMode={false}
                dialogMessage={t("dialogModals.confirmDeleteGroup")}
                handleOnDelete={() => props.handleDeleteGroup!(item)}
              />
            )}
          </CellBox>
          <BorderRow />
        </BasicTableRowStyles>
      )}
    </TableWrapper>
  );
};
